<template lang="pug">
  article.l-home.v2
    .l-home__logo
      img(src="../../assets/img/logo/logo-square.png")
    .l-home-headline.u-text-center 近所で好きな時に、
      div 高時給で働ける仕事アプリ
    .l-home__bottom
      .c-button-group--v2
        router-link.u-mts.c-button.c-button--block.c-button-outline--secondary(v-bind:to="{ name: 'emailAuthorization' }") 新規会員登録
      .u-mtl.u-mbxl.u-text-center
        .u-text-center
          router-link(v-bind:to="{ name: 'signupFlow' }") 会員登録の流れ
      .u-mvs.u-phl
        small.l-home__text
          | ギグベースを利用することにより、ギグベースの
          a.u-text-underline(href="https://gigbase.jp/terms" target="_blank") 利用規約
          | と
          a.u-text-underline(href="https://gigbase.jp/personal" target="_blank") プライバシーポリシー
          | に同意したものと見なされます。
</template>

<script lang="babel">
import INDEED_REFS from "@/constants/indeedRefs";
import { WORKER_KEY } from "@/constants/localStorageKeys";
import {inject} from "vue";
import {SIGNUP_STORE} from "@/constants/InjectionKeys";

export default {
  created() {
    this.$emit('page-navbar', false);
    this.setQuery();
  },
  methods: {
    setQuery() {
      // ライフサイクルの都合でパースしているが、メモリ食いそうなのでApp.vueのmountedで処理したい感
      const worker = JSON.parse(localStorage.getItem(WORKER_KEY));
      const referrer = Number(this.$route.query.referrer);
      const invitationCode = this.$route.query.invitation_code;
      const payload = {};

      if (referrer !== null && !isNaN(referrer) && INDEED_REFS.includes(referrer)) {
        payload.referrer = referrer;
      }
      if (invitationCode != null) {
        payload.invitation_code = invitationCode;
      }

      const { setWorker } = inject(SIGNUP_STORE)
      setWorker({ ...worker, ...payload })
    }
  }
}
</script>

<style lang="scss" scoped>
  .l-home.v2 {
    max-width: 540px;
    margin: 0 auto;
    background-image: none !important;
    .l-home__logo {
      top: 17vh;
      left: 0;
      right: 0;
      text-align: center;
      img {
        max-width: 186px;
        max-height: 186px;
      }
    }
    .l-home-headline {
      font-weight: bold;
      font-size: 16px;
      line-height: 16px;
      color: #1D1918;
      letter-spacing: 0.05em;
    }

    .l-home__bottom.v2 {
      padding: {
        right: 32px;
        left: 32px;
      }
    }
    .c-button-group--v2 {
      &:last-child {
        margin-top: 10px;
      }
    }
    .c-button--primary {
      background-color: #F94848;
      border-color: #F94848;
    }
    .c-button-outline--secondary {
      color: #F94848;
      border-color: #F94848;
      &:hover,  &:active, &:focus {
        color: white;
      }
    }
    .l-home__text {
      font-size: 10px;
      line-height: 10px;
      text-align: center;
      color: #A6A5A5;
    }

  }
</style>
